import { render, staticRenderFns } from "./MaintenanceNew.vue?vue&type=template&id=6750fe6a&"
import script from "./MaintenanceNew.vue?vue&type=script&lang=js&"
export * from "./MaintenanceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports